import { useState } from "react";
import { Modal } from "@/components/ui-mm/Modal";
import { t } from "@/lib/i18n";

const KEYS = [["Deg", "deg", "op"], ["sin", "sin(", "op"], ["cos", "cos(", "op"], ["tan", "tan(", "op"], ["⌫", "bs", "op"],
  ["ln", "ln(", "op"], ["log", "log(", "op"], ["(", "(", ""], [")", ")", ""], ["xʸ", "^", "op"],
  ["7", "7", ""], ["8", "8", ""], ["9", "9", ""], ["÷", "/", "op"], ["C", "c", "op"],
  ["4", "4", ""], ["5", "5", ""], ["6", "6", ""], ["×", "*", "op"], ["√", "sqrt(", "op"],
  ["1", "1", ""], ["2", "2", ""], ["3", "3", ""], ["−", "-", "op"], ["%", "%", "op"],
  ["0", "0", ""], [".", ".", ""], ["π", "pi", ""], ["+", "+", "op"], ["=", "=", "eq"]];

// Safe recursive-descent evaluator (no eval)
function evaluate(src, deg) {
  const T = src.match(/\d*\.?\d+|\d+\.|[a-z]+|[-+*/^!%()]/g) || [];
  if (T.join("") !== src.replace(/\s/g, "")) throw new Error("bad");
  let p = 0;
  const pk = () => T[p], nx = () => T[p++];
  const D = (x) => (deg ? (x * Math.PI) / 180 : x);
  const F = { sin: (x) => Math.sin(D(x)), cos: (x) => Math.cos(D(x)), tan: (x) => Math.tan(D(x)), ln: Math.log, log: Math.log10, sqrt: Math.sqrt };
  const fact = (n) => { if (n < 0 || n > 170 || n % 1) throw new Error("bad"); let r = 1; for (let i = 2; i <= n; i++) r *= i; return r; };
  const ex = () => { let v = tm(); while (pk() === "+" || pk() === "-") { const o = nx(), r = tm(); v = o === "+" ? v + r : v - r; } return v; };
  const tm = () => { let v = un(); while (pk() === "*" || pk() === "/") { const o = nx(), r = un(); v = o === "*" ? v * r : v / r; } return v; };
  const un = () => (pk() === "-" ? (nx(), -un()) : pk() === "+" ? (nx(), un()) : pw());
  const pw = () => { const b = pf(); return pk() === "^" ? (nx(), Math.pow(b, un())) : b; };
  const pf = () => { let v = pr(); for (;;) { if (pk() === "!") { nx(); v = fact(v); } else if (pk() === "%") { nx(); v /= 100; } else return v; } };
  const pr = () => {
    const t = nx();
    if (t === undefined) throw new Error("bad");
    if (/^[\d.]/.test(t)) return parseFloat(t);
    if (t === "pi") return Math.PI;
    if (t === "e") return Math.E;
    if (t === "(") { const v = ex(); if (nx() !== ")") throw new Error("bad"); return v; }
    if (F[t]) { if (nx() !== "(") throw new Error("bad"); const v = ex(); if (nx() !== ")") throw new Error("bad"); return F[t](v); }
    throw new Error("bad");
  };
  const v = ex();
  if (p !== T.length || !Number.isFinite(v)) throw new Error("bad");
  return Math.round(v * 1e10) / 1e10;
}

export default function Calculator({ open, onClose }) {
  const [x, setX] = useState("");
  const [res, setRes] = useState("0");
  const [deg, setDeg] = useState(true);
  const press = (k) => {
    if (k === "c") { setX(""); setRes("0"); return; }
    if (k === "bs") return setX(x.replace(/(sin\(|cos\(|tan\(|ln\(|log\(|sqrt\(|pi|.)$/, ""));
    if (k === "deg") return setDeg(!deg);
    if (k === "=") { try { const v = evaluate(x, deg); setRes(String(v)); setX(String(v)); } catch (e) { setRes("Error"); } return; }
    setX(x + k);
  };
  const use = () => { const v = parseFloat(res); if (v > 0) { window.dispatchEvent(new CustomEvent("mm-amount", { detail: Math.round(v * 100) / 100 })); onClose(); } };
  return (
    <Modal open={open} onClose={onClose} title={t("Calculator")} testId="calculator-dialog">
      <div className="rounded-[var(--ri)] bg-[var(--bg)] p-4 text-right">
        <div className="num min-h-[1.5rem] break-all text-sm text-[var(--mu)]" data-testid="calculator-expression">{x.replace(/\*/g, "×").replace(/\//g, "÷").replace(/pi/g, "π") || " "}</div>
        <div className="num break-all text-3xl font-bold" data-testid="calculator-result">{res}</div>
      </div>
      <div className="mm-calc mt-3 grid grid-cols-5 gap-2">
        {KEYS.map(([l, k, c]) => <button key={k} className={c} onClick={() => press(k)} data-testid={`calc-key-${k.replace(/\W/g, "") || l}`}>{k === "deg" ? (deg ? "Deg" : "Rad") : l}</button>)}
      </div>
      <button className="mm-btn mt-4 w-full justify-center" onClick={use} disabled={!(parseFloat(res) > 0)} data-testid="calculator-use-amount-button">{t("Use as expense amount")}</button>
    </Modal>
  );
}
